import type * as React from "react";
import { connect } from "react-redux";
import {
    KeywordGeneratorToolPageTableBase,
    mapDispatchToPropsBase,
    mapStateToPropsBase,
} from "./KeywordGeneratorToolPageBase";
import { PhraseMatchTableSettings } from "./PhraseMatchTableSettings";
import CountryService from "app/services/CountryService";
import { shortMonthAndYear } from "@similarweb/pro-logic-components";
import DurationService, { BasicDurations } from "app/services/DurationService";
import { capitalizeIntent } from "app/pages/keyword-research/keyword-analysis/pages/keyword-generator/google-keyword-generator/utils";
import { getVolumeValue } from "app/pages/website-analysis/traffic-sources/search/common/utils";
import { TABLE_TYPES_FOR_ENDPOINT } from "app/common/keyword-research/keyword-generator/constants";
import type { IGoogleKeywordGeneratorApiResponse } from "app/common/keyword-research/keyword-generator/types";

export const paramsWithUpdatedRangeFilterAndKeyword = (params, duration) => {
    const updatedParams = { ...params };
    if (
        params.rangeFilter &&
        params.rangeFilter.includes("volume") &&
        duration === BasicDurations.LAST_TWENTY_EIGHT_DAYS
    ) {
        updatedParams.rangeFilter = updatedParams.rangeFilter.replace("volume", "dailyVolume");
    }
    return updatedParams;
};

class KeywordGeneratorToolPageTable extends KeywordGeneratorToolPageTableBase {
    protected tableSettings = PhraseMatchTableSettings;
    protected tableStorageKey = "KeywordGeneratorToolTable";
    protected dropdownAppendTo = ".firstTab .swReactTable-header-wrapper";

    protected dataParamsAdapter = (params) => {
        return {
            ...paramsWithUpdatedRangeFilterAndKeyword(params, this.props.duration),
            type: TABLE_TYPES_FOR_ENDPOINT.broad,
        };
    };

    protected getDataCallback = (data) => {
        this.setState({
            totalVisits: data.totalVisits,
            totalClicks: data.totalClicks,
            totalVolume: data.totalVolume,
            totalRows: data.totalRecords,
        });
        if (typeof this.props.getDataCallback === "function") {
            this.props.getDataCallback(data);
        }
        if (this.props.selectRows) {
            this.props.selectAllRows(data.records);
        }
    };

    protected transformData = (data: IGoogleKeywordGeneratorApiResponse) => {
        return {
            ...data,
            records: data.records.map((keywordGroupDetail) => {
                const countryName = CountryService.getCountryById(this.props.country).text;
                const durationText = DurationService.getFormattedDateOutOfDurationParam(
                    this.props.duration,
                    shortMonthAndYear,
                );
                return {
                    ...keywordGroupDetail,
                    averageVolume: getVolumeValue(keywordGroupDetail.averageVolume),
                    monthlyVolume: getVolumeValue(keywordGroupDetail.monthlyVolume),
                    windowVolume: getVolumeValue(keywordGroupDetail.windowVolume),
                    SearchTerm: keywordGroupDetail.keyword,
                    url: this.getUrlForKeyWord(keywordGroupDetail.keyword),
                    country: this.props.country,
                    countryName,
                    durationText,
                    intents: {
                        PrimaryIntent: capitalizeIntent(keywordGroupDetail.primaryIntent),
                        SecondaryIntent: capitalizeIntent(keywordGroupDetail.secondaryIntent),
                    },
                    web_source: this.props.webSource,
                    organicShare: keywordGroupDetail.paidShare === 0 ? 1 : keywordGroupDetail.organicShare,
                };
            }),
        };
    };
}

export default connect(
    mapStateToPropsBase,
    mapDispatchToPropsBase,
)(KeywordGeneratorToolPageTable as React.ComponentType<any>);
